"use client";

import { GE } from ".constants/gtmEvents";
import { Button, Icon } from "@cloai/uikit";
import { FC, memo } from "react";

import { useAutoMaskContext, useGTMContext } from "@/providers";
import { cn } from "@/utils/cn";

import { Cursor } from "./Cursor";
import { useDrawing } from "./useDrawing";

interface IPhotoEditorProps {
  id: string;
  image: string;
}

export const AutoMask: FC<IPhotoEditorProps> = memo(
  ({ id, image: originalImage }) => {
    const { isShowDraw, isMaskLoading } = useAutoMaskContext();
    const { sendGTM } = useGTMContext();

    const { canvasRef, handlers, cursorProps, getAutoMask } = useDrawing(
      id,
      originalImage,
    );

    const handleGetAutoMask = () => {
      sendGTM({ event: GE.FLOW_CLICK_DRAW__GET_AUTOMASK });
      getAutoMask();
    };

    // WARNING: не трогать классы и обёртки!!! только такой сетап работает в Chrome+Safari !!!
    return (
      <div
        className={cn(
          "pointer-events-none absolute inset-0 size-full",
          isShowDraw && "pointer-events-auto",
        )}
      >
        <div
          className="absolute inset-0 m-auto max-h-full max-w-full overflow-hidden"
          style={{
            aspectRatio:
              (canvasRef.current?.width ?? 1) /
              (canvasRef.current?.height ?? 1),
          }}
        >
          <canvas
            ref={canvasRef}
            className={cn(
              "relative size-full",
              "touch-none object-contain opacity-60 select-none",
            )}
            {...handlers}
          />

          {isShowDraw && <Cursor {...cursorProps} />}
        </div>

        {isShowDraw && (
          <Button
            isIconOnly
            color="secondary"
            radius="full"
            size="md"
            className="pointer-events-auto absolute top-2 right-2"
            onClick={handleGetAutoMask}
            loading={isMaskLoading}
          >
            <Icon icon="format_shapes" className="text-secondary-foreground" />
          </Button>
        )}
      </div>
    );
  },
);

AutoMask.displayName = "AutoMask";
